<ion-header translucent="true" *transloco="let t">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="ios" (click)="dismiss()">{{ t('cancel') }}</ion-button>
      <ion-button *ngIf="!ios" (click)="reset()">{{ t('reset') }}</ion-button>
    </ion-buttons>

    <ion-title> {{ t('editColumns') }} </ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="applyFilters()" strong>{{ t('done') }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *transloco="let t">
  <ion-list [lines]="ios ? 'inset' : 'full'">
    <ion-list-header>{{ t('columns') }}</ion-list-header>

    <ion-item *ngFor="let col of columns" [attr.col]="col.field | lowercase">
      <ion-checkbox [(ngModel)]="col.visible"
        >{{ t(pageType + col.field) }}</ion-checkbox
      >
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer translucent="true" *ngIf="ios">
  <ion-toolbar *transloco="let t">
    <ion-buttons slot="start">
      <ion-button (click)="selectAll(false)">{{ t('deselectAll') }}</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="selectAll(true)">{{ t('selectAll') }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
